import { render } from "./RegisterInput.vue?vue&type=template&id=51a4bd75&scoped=true"
import script from "./RegisterInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterInput.vue?vue&type=script&setup=true&lang=js"

import "./RegisterInput.vue?vue&type=style&index=0&id=51a4bd75&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a4bd75"],['__file',"src/views/register/RegisterInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51a4bd75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51a4bd75', __exports__)) {
    api.reload('51a4bd75', __exports__)
  }
  
  module.hot.accept("./RegisterInput.vue?vue&type=template&id=51a4bd75&scoped=true", () => {
    api.rerender('51a4bd75', render)
  })

}


export default __exports__